<template>
  <div ref="container"
       style="display: flex;
             align-items: center;
             justify-content: center;
             width: 100%;
             height: 100%;
             position: relative">
    <slot></slot>
  </div>
</template>

<script>
  import Vue from 'vue'

  import RoseOfWindChart from './rose-of-wind-chart'

  export default {
    name: "rose-of-wind-chart",

    //передоваемые параметры
    props: {
      data: {
        type: Array,
        default: () => []
      },
      option: {
        type: Object,
        default: () => ({})
      }
    },
    // локальное состояние
    data() {
      return {
        defOprion: {},
        defaultSize: {
          width: 500,
          height: 500,
          margin: {
            left: 100,
            right: 100,
            top: 100,
            bottom: 100,
          }
        }
      }
    },


    mounted() {
      this.updateChart();
      window.addEventListener('resize', this.updateChart);
    },

    //вычисляемые свойства (https://ru.vuejs.org/v2/guide/computed.html#Вычисляемые-свойства)
    computed: {},
    //Методы для изменения локального состояния.Ограничения (https://ru.vuejs.org/v2/guide/list.html#Отслеживание-изменений-в-массивах)
    methods: {
      updateChart() {
        let width, height;

        width = height = Math.min(this.$refs.container.clientWidth, this.$refs.container.clientHeight);

        const wScale = width / this.defaultSize.width;

        const margin = {};

        margin.left = this.defaultSize.margin.left * wScale;
        margin.right = this.defaultSize.margin.right * wScale;

        const hScale = height / this.defaultSize.height;
        margin.top = this.defaultSize.margin.top * hScale;
        margin.bottom = this.defaultSize.margin.bottom * hScale;

        const options = {
          w: width - margin.left - margin.right,
          h: height - margin.top - margin.bottom,
          margin: margin,
          autoAxisMaxValue: true,
          axisMargin: 30,
          container: this.$refs.container
        };

        for (let i in this.option)
          if (this.option.hasOwnProperty(i) && 'undefined' !== typeof this.option[i])
            options[i] = this.option[i];

        for (let i in this.defOprion)
          if (this.defOprion.hasOwnProperty(i) && 'undefined' !== typeof this.defOprion[i] && 'undefined' === typeof options[i])
            options[i] = this.defOprion[i];

        RoseOfWindChart(this.data, options);
      }
    },

    components: {},

    watch: {
      data() {
        this.updateChart();
      },
      option() {
        this.updateChart();
      }
    }

  }
</script>

<style scoped>

</style>
